import { render, staticRenderFns } from "./Coparticipacao.vue?vue&type=template&id=a0a1f96a&"
import script from "./Coparticipacao.vue?vue&type=script&lang=js&"
export * from "./Coparticipacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports